import { z } from 'zod';
import { ingredientCategorySchema } from '../constants/categories.js';
import { seasonSchema } from '../constants/seasons.js';
// ---------------------------------------------------------------------------
// Cooking Method (jsonb structure within ingredient_refs)
// ---------------------------------------------------------------------------
export const CookingMethodSchema = z.object({
    method: z.string(),
    temperature: z.string().nullable().optional(),
    duration: z.string().nullable().optional(),
    tips: z.string().nullable().optional(),
});
// ---------------------------------------------------------------------------
// Conservation (jsonb structure within ingredient_refs)
// ---------------------------------------------------------------------------
const ConservationDetailSchema = z.object({
    duration: z.string().nullable().optional(),
    tips: z.string().nullable().optional(),
});
export const ConservationSchema = z.object({
    fridge: ConservationDetailSchema.nullable().optional(),
    freezer: ConservationDetailSchema.nullable().optional(),
    pantry: ConservationDetailSchema.nullable().optional(),
});
// ---------------------------------------------------------------------------
// Ingredient Reference (global catalog)
// ---------------------------------------------------------------------------
/** A description says what the ingredient is in a few lines, not its history. */
export const INGREDIENT_DESCRIPTION_MAX_LENGTH = 600;
export const IngredientRefSchema = z.object({
    id: z.string().uuid(),
    name: z.string().min(1),
    /** Other names it goes by: matched and searched like the name, shown on the card. */
    aliases: z.array(z.string().min(1)).default([]),
    category: ingredientCategorySchema,
    seasons: z.array(seasonSchema).default([]),
    months: z.array(z.number().int().min(1).max(12)).default([]),
    description: z.string().nullable().default(null),
    cooking_methods: z.array(CookingMethodSchema).nullable().default(null),
    preparation_tips: z.array(z.string()).default([]),
    conservation: ConservationSchema.nullable().default(null),
    general_tips: z.array(z.string()).default([]),
    // Density / conversion data
    density_g_per_ml: z.number().positive().nullable().default(null),
    tablespoon_g: z.number().positive().nullable().default(null),
    cup_g: z.number().positive().nullable().default(null),
    // Shopping list defaults
    preferred_units: z.array(z.string()).default([]),
    typical_quantities: z.array(z.number()).default([]),
    image_url: z.string().url().nullable().default(null),
    /** The 30 px illustration drawn for lists. */
    icon_url: z.string().url().nullable().default(null),
    created_at: z.string().datetime(),
    updated_at: z.string().datetime(),
});
// ---------------------------------------------------------------------------
// Ingredient Family Override
// ---------------------------------------------------------------------------
export const IngredientFamilyOverrideSchema = z.object({
    id: z.string().uuid(),
    ingredient_ref_id: z.string().uuid(),
    family_id: z.string().uuid(),
    description: z.string().nullable().default(null),
    cooking_methods: z.array(CookingMethodSchema).nullable().default(null),
    preparation_tips: z.array(z.string()).default([]),
    conservation: ConservationSchema.nullable().default(null),
    general_tips: z.array(z.string()).default([]),
    updated_by: z.string().uuid(),
    updated_at: z.string().datetime(),
});
//# sourceMappingURL=ingredient-ref.js.map